import React, { useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import LocalStorageUtils from '../../utils/local-storage';
import { PAMMState } from '../../redux/reducers/rootReducer';
import fetchInvestorDetailsAsync from '../../redux/actions/investor/fetchInvestorDetails';
import { AccountType } from '../../types/authTypes';
import { fetchSharedSettingsAsync } from '../../redux/actions/shared/fetchConfig';
import styles from './BottomBarMobile.module.css';
import { applyStyles } from '../../utils/applyStyles';
import HomePageIcon from '../../icons/HomePageIcon';
import MoneyManagersIcon from '../../icons/MoneyManagersIcon';
import RequestsIcon from '../../icons/RequestsIcon';
import AccountSettingsIcon from '../../icons/AccountSettingsIcon';
import fetchProfitAsync from '../../redux/actions/shared/fetchProfit';
import PAMMDateTime from '../../utils/date-time';
import { CalcMethod, GraphicsPeriodTypes, ProfitMode } from '../../types/sharedTypes';
import { Investor } from '../../types/investorTypes';

const BottomBarMobile: React.FC<any> = ({ user, location }): JSX.Element => {
  const dispatch = useDispatch();
  const api: string = useSelector((state: PAMMState) => state.configReducer.api);
  const sharedConfig = useSelector((state: PAMMState) => state.configReducer.sharedConfig);

  const investor: Investor = useSelector((state: PAMMState) => state.investorReducer.investor);
  const linkedAccounts: Array<Investor> = useSelector((state: PAMMState) => state.investorsReducer.investors);

  const linkedId = LocalStorageUtils.getValueFromLocalStorage('linkedIdMobile') || user.Id;
  const registrationDate = user?.AccountInfo?.IsOwnFunds === false ? investor?.CreationTime : user?.AccountInfo?.RegistrationDate;

  useEffect(() => {
    if (user?.Id) {
      const accountId = user?.Id;
      const ownFundsId = user?.AccountInfo?.OwnFunds?.Id;
      let investorId = 0;

      if (user.AccountType === AccountType.Master) {
        if (location.pathname.includes('investors/') && investor.CreationTime) {
          const match = location.pathname.match(/\/investors\/(\d+)/);
          investorId = match ? match[1] : null;

          dispatch(
            fetchProfitAsync(
              api,
              investorId,
              GraphicsPeriodTypes.AllTime,
              new PAMMDateTime(investor.CreationTime).getDateObject(),
              new Date(),
              CalcMethod.Regular,
              false,
              false,
              ProfitMode.Percent,
              AccountType.Investor
            )
          );
        }

        dispatch(
          fetchProfitAsync(
            api,
            accountId,
            GraphicsPeriodTypes.AllTime,
            new PAMMDateTime(registrationDate).getDateObject(),
            new Date(),
            CalcMethod.Regular,
            false,
            false,
            ProfitMode.Percent,
            AccountType.Master
          )
        );
        dispatch(
          fetchProfitAsync(
            api,
            ownFundsId,
            GraphicsPeriodTypes.AllTime,
            new PAMMDateTime(registrationDate).getDateObject(),
            new Date(),
            CalcMethod.Regular,
            false,
            false,
            ProfitMode.Percent,
            AccountType.OwnFunds
          )
        );
      } else if (user.AccountType === AccountType.Investor && !user.LinkToken && investor.CreationTime) {
        dispatch(
          fetchProfitAsync(
            api,
            accountId,
            GraphicsPeriodTypes.AllTime,
            new PAMMDateTime(registrationDate).getDateObject(),
            new Date(),
            CalcMethod.Regular,
            false,
            false,
            ProfitMode.Percent,
            AccountType.Investor
          )
        );
      }
    }
  }, [dispatch, api, location.pathname, investor]);

  const fetchProfitForAccount = (accountId: number, creationTime: string) => {
    if (user.LinkToken) {
      dispatch(
        fetchProfitAsync(
          api,
          accountId,
          GraphicsPeriodTypes.AllTime,
          new PAMMDateTime(creationTime).getDateObject(),
          new Date(),
          CalcMethod.Regular,
          true,
          false,
          ProfitMode.Percent
        )
      );
    }
  };

  useEffect(() => {
    linkedAccounts.forEach((investorAccount) => {
      fetchProfitForAccount(investorAccount.Id, investorAccount.CreationTime);
    });
  }, [dispatch, api, linkedAccounts.length]);

  useEffect(() => {
    if (user?.Id && user?.AccountType === AccountType.Investor) {
      let investorId = 0;

      if (user?.AccountType === AccountType.Investor) {
        if (user?.AccountInfo?.LinkToken) {
          investorId = Number(linkedId);
        } else {
          investorId = user?.Id;
        }
      }

      dispatch(fetchInvestorDetailsAsync(api, investorId));
    }
  }, [dispatch, api, linkedId]);

  useEffect(() => {
    dispatch(fetchSharedSettingsAsync(api));
  }, [dispatch, api, sharedConfig?.RequestTab]);

  const showMoneyManagers = user?.AccountInfo?.AccountOptions?.MasterList === 'Show' && user.AccountType === 'investor';
  const showRequests = sharedConfig?.RequestTab?.toString() !== 'false';

  const MenuItem: React.FC<{ to: string; icon: JSX.Element; labelId: string }> = ({ to, icon, labelId }) => {
    return (
      <NavLink
        to={to}
        className={applyStyles([styles['navbar-menu-item'], 'text-semibold'])}
        activeClassName={applyStyles([styles['item-active'], 'text-semibold'])}
      >
        <span className={styles['icon-wrapper']}>{icon}</span>
        {/* // TODO waiting for the review */}
        {/* <span className={styles['label']}>
          <FormattedMessage id={labelId} />
        </span> */}
      </NavLink>
    );
  };

  return (
    <div className={styles['navbar-menu']}>
      <MenuItem to="/dashboard" icon={<HomePageIcon />} labelId="bottomBar.main" />
      {showMoneyManagers && <MenuItem to="/money_managers" icon={<MoneyManagersIcon />} labelId="bottomBar.masters" />}
      {showRequests && <MenuItem to="/requests" icon={<RequestsIcon />} labelId="bottomBar.requests" />}
      <MenuItem to="/profile" icon={<AccountSettingsIcon />} labelId="bottomBar.profile" />
    </div>
  );
};

export default withRouter(BottomBarMobile);
